import {
  Chart as ChartJS,
  BarController,
  BarElement,
  Filler,
  Interaction,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
} from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';

const TOOLTIP_MAX_PX = 40;

/**
 * Hover picks the nearest point in x from each series separately.
 * Index mode pairs points by array position, which misses when the
 * measured line and the forecast use different timestamps.
 */
Interaction.modes.nearestPerDataset = (chart, event, options, useFinalPosition) => {
  const position = getRelativePosition(event, chart);
  const items = [];
  chart.data.datasets.forEach((dataset, datasetIndex) => {
    if (dataset.excludeFromTooltip || !chart.isDatasetVisible(datasetIndex)) return;
    let best = null;
    let bestDistance = TOOLTIP_MAX_PX;
    chart.getDatasetMeta(datasetIndex).data.forEach((element, index) => {
      if (element.skip) return;
      const { x } = element.getProps(['x'], useFinalPosition);
      const distance = Math.abs(x - position.x);
      if (distance <= bestDistance) {
        bestDistance = distance;
        best = { element, datasetIndex, index };
      }
    });
    if (best) items.push(best);
  });
  return items;
};

ChartJS.register(
  BarController,
  BarElement,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
  zoomPlugin
);

export const CHART_FONT = "'IBM Plex Sans', sans-serif";
export const NUMBER_FONT = "'IBM Plex Mono', ui-monospace, monospace";

export const formatAxisNumber = (value) => String(Number(Number(value).toFixed(2)));

export function lockAxisWidth(scale) {
  scale.width = 64;
}

ChartJS.defaults.font.family = CHART_FONT;
ChartJS.defaults.color = '#3F4441';
